import { createUseStyles } from 'react-jss';
import { theme } from '@align-cpf/uikit-styles';

const { colors, spacing } = theme;

export default createUseStyles(
  {
    root: {
      maxWidth: '100%',
      userSelect: 'none',
      background: 'none',
      position: 'relative',
      letterSpacing: 0,
      padding: [0, 0, 1],
      margin: 0,
      font: 'inherit',
      transition: 'all .25s ease-out',
      height: 'max-content',
      color: colors.textPrimary,
      boxSizing: 'border-box',
      border: 'none',
      borderBottom: [1, 'solid', 'transparent'],
      borderBottomColor: colors.borderSubtle,
      borderRadius: 0,
      '&:hover': {
        borderBottomColor: colors.borderSubtleHover,
      },
      '$selected&': {
        borderBottomColor: colors.borderInteractive,
      },
      '&:hover, $selected&': {
        padding: 0,
        borderBottomWidth: 2,
      },
      '$disabled&': {
        pointerEvents: 'none',
        color: colors.textDisabled,
      },
      '&:focus-visible': {
        outline: [1, 'solid', colors.borderFocus],
        outlineOffset: -1,
      },
    },
    tabLabelText: {
      cursor: 'pointer',
      display: 'block',
      padding: [spacing.sp03, spacing.sp04],
    },
    selected: {},
    disabled: {},
  },
  {
    name: 'TabLabel',
  },
);
